import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { requestableCategoryRepository } from '@webapp/modules/expense/data-access/repositories/RequestableCategoryRepository'
import messages from './messages'

export type RequestableSecondaryCategorySelectValue = {
  id: number
  name: string
}

export interface IRequestableSecondaryCategorySelectProps extends IAsyncSelectProps<RequestableSecondaryCategorySelectValue> {
  locationId: Nullable<number>
}

export const RequestableSecondaryCategorySelect = ({
  locationId,
  ...props
}: IRequestableSecondaryCategorySelectProps) => {
  const intl = useProcurifyIntl()

  const loadOptions: IAsyncSelectProps<RequestableSecondaryCategorySelectValue>['loadOptions'] =
    (inputValue, pagination, callback) => {
      if (locationId === null) {
        callback({
          options: [],
          pagination: {
            hasMore: false,
            page: 1,
          },
        })
        return
      }

      requestableCategoryRepository
        .listRequestableDepartments({
          branchId: locationId,
          search: inputValue,
          page: pagination.page,
        })
        .then((res) => {
          callback({
            options: res.data.map((dept) => ({
              id: dept.id,
              name: dept.name,
            })),
            pagination: {
              hasMore: res.pagination
                ? res.pagination.page < res.pagination.numPages
                : false,
              page: pagination.page + 1,
            },
          })
        })
        .catch(() => {
          callback({
            options: [],
            pagination: { hasMore: false, page: 1 },
          })
        })
    }

  return (
    <AsyncSelect<RequestableSecondaryCategorySelectValue>
      cacheOptions={true}
      clearCacheOnMenuClose
      loadOptions={loadOptions}
      placeholder={intl.formatMessage(messages.placeholderText)}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id.toString()}
      isDisabled={locationId === null}
      {...props}
    />
  )
}
